/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
/* eslint-disable */
import { FormEditCreateUpdateProcessOrderPackagingFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/process-order-packaging/create-update/form-edit-create-update-process-order-packaging-field-dialog.component';
/* eslint-enable */

/* eslint-enable */

export class FormEditProcessOrderPackagingFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateProcessOrderPackagingFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateProcessOrderPackagingFieldDialogComponent)
      .create(this.injector);
  }

}
